import { render, staticRenderFns } from "./KimsaPhoneField.vue?vue&type=template&id=4b855846&scoped=true"
import script from "./KimsaPhoneField.vue?vue&type=script&lang=js"
export * from "./KimsaPhoneField.vue?vue&type=script&lang=js"
import style0 from "./KimsaPhoneField.vue?vue&type=style&index=0&id=4b855846&prod&scoped=true&lang=css"
import style1 from "./KimsaPhoneField.vue?vue&type=style&index=1&id=4b855846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b855846",
  null
  
)

export default component.exports